const refinishingOpt1 = document.querySelector('#refinishingOpt1');
const colorSpecify = document.querySelector('.colorSpecify');
const colorUser = document.querySelector('#colorUser');
const cartForm = document.querySelector('.js-product-form')
const realCartBtn = document.querySelector('[name="add"]')
const productVariantId = document.querySelector("[name='id']").value
const productQuantity = document.querySelector("[name='quantity']").value
const productPricing = document.querySelector('.price__current');
const salePrice = document.querySelector('.price__was')
let currentPrice;
let totalPrice;
if (salePrice.innerText !== '') {
  currentPrice = parseFloat(salePrice.innerText.replace(/[$,]/g, ''))
  totalPrice = currentPrice;
} else {
  currentPrice = parseFloat(productPricing.innerText.replace(/[$,]/g, ''))
  totalPrice = currentPrice;
}
let addedPrice = refinishingOpt1 ? parseFloat(document.querySelector('#refinishingOpt1').dataset.extraprice) : ''
let addExtra = ''
let variantVerbage = ''



if (refinishingOpt1 !== null) {
if(realCartBtn.getAttribute('disabled') !== 'disabled'){
  const fakeCartBtn = document.createElement('button')
  fakeCartBtn.type = 'button'
  fakeCartBtn.className = "btn btn--large hidden";
  fakeCartBtn.style= 'width: 100%;'
  fakeCartBtn.innerText = realCartBtn.innerText
  fakeCartBtn.id = 'fakeCartBtn'
  cartForm.appendChild(fakeCartBtn)
}

refinishingOpt1.addEventListener('change', () => {

  variantVerbage = ''
  
  if (refinishingOpt1.checked) {
    const fakeBtn = document.querySelector("#fakeCartBtn")
    if(fakeBtn != null){
    const boldCartBtn = document.querySelector('.bold_clone')
    realCartBtn.classList.add('hidden')
      if (boldCartBtn !== null) {
        boldCartBtn.classList.add('hide')
      }
    fakeCartBtn.classList.remove('hidden')
    }
    if (refinishingOpt1.dataset.tag == 'vintage-chest-large') {
      addExtra = '40704811368606'
      variantVerbage = 'Add Refinishing'
    }
    if (refinishingOpt1.dataset.tag == 'vintage-chest-medium'){
      addExtra = '40704810385566'
      variantVerbage = 'Add Refinishing'
    }
    if (refinishingOpt1.dataset.tag == 'vintage-chest-small'){
      addExtra = '40704789545118'
      variantVerbage = 'Add Refinishing'
    }
    if (refinishingOpt1.dataset.tag == 'vintage-credenza-large'){
      addExtra = '40698725859486'
      variantVerbage = 'Add Refinishing'
    }
    if (refinishingOpt1.dataset.tag == 'vintage-credenza-small'){
      addExtra = '40698721697950'
      variantVerbage = 'Add Refinishing'
    }
    if (refinishingOpt1.dataset.tag == 'vintage-console-large'){
      addExtra = '40704811368606'
      variantVerbage = 'Add Refinishing'
    }
    if (refinishingOpt1.dataset.tag == 'vintage-console-medium'){
      addExtra = '40704810385566'
      variantVerbage = 'Add Refinishing'
    }
    if (refinishingOpt1.dataset.tag == 'vintage-console-small'){
      addExtra = '40704789545118'
      variantVerbage = 'Add Refinishing'
    }
    if (refinishingOpt1.dataset.tag == 'Vintage-swivels'){
      addExtra = '40704908230814'
      variantVerbage = 'Upholstery Labor'
    } 
    if (refinishingOpt1.dataset.tag == 'vintage-club-chair'){
      addExtra = '40705494712478'
      variantVerbage = 'Upholstery Labor'
    }
    if (refinishingOpt1.dataset.tag == 'vintage-chair'){
      addExtra = '40704908230814'
      variantVerbage = 'Upholstery Labor'
    }
    if (refinishingOpt1.dataset.tag == 'barstool'){
      addExtra = '41513668870302'
      variantVerbage = 'Upholstery Labor'
    }
    if (refinishingOpt1.dataset.tag == "$2650 upholstery labor"){
      addExtra = '42914441101470'
      variantVerbage = 'Re-upholstery Labor'
    }
    if (refinishingOpt1.dataset.tag == "$1650 upholstery labor"){
      addExtra = '42914441068702'
      variantVerbage = 'Re-upholstery Labor'
    }
    if (refinishingOpt1.dataset.tag == "$950 upholstery labor"){
      addExtra = '42914441035934'
      variantVerbage = 'Re-upholstery Labor'
    }
    if (refinishingOpt1.dataset.tag == "$750 upholstery labor"){
      addExtra = '42914441003166'
      variantVerbage = 'Re-upholstery Labor'
    }
    if (refinishingOpt1.dataset.tag == "$650 upholstery labor"){
      addExtra = '42914440970398'
      variantVerbage = 'Re-upholstery Labor'
    }
    if (refinishingOpt1.dataset.tag == "$550 upholstery labor"){
      addExtra = '42914440937630'
      variantVerbage = 'Re-upholstery Labor'
    }
    if (refinishingOpt1.dataset.tag == "$450 upholstery labor"){
      addExtra = '42914440904862'
      variantVerbage = 'Re-upholstery Labor'
    }
    if (refinishingOpt1.dataset.tag == "$350 upholstery labor"){
      addExtra = '42914440872094'
      variantVerbage = 'Re-upholstery Labor'
    }
    if (refinishingOpt1.dataset.tag == "$250 upholstery labor"){
      addExtra = '42914440839326'
      variantVerbage = 'Re-upholstery Labor'
    }
    if (colorSpecify != null) {
      colorSpecify.style.display = 'block';
    }
    totalPrice = currentPrice + addedPrice;
    if (salePrice.innerText !== '') {
      salePrice.textContent = formatCurrency(totalPrice);
    } else {
      productPricing.textContent = formatCurrency(totalPrice);
    }
  } else {
    if(fakeBtn != null){
    realCartBtn.classList.remove('hidden')
    realCartBtn.classList.remove('bold_hidden')
    realCartBtn.style.display = 'block'
    fakeCartBtn.classList.add('hidden')
    }
    if (colorSpecify != null) {
      colorUser.value = '';
      colorSpecify.style.display = 'none';
    }
    totalPrice = currentPrice;
    if (salePrice.innerText !== '') {
      salePrice.textContent = formatCurrency(totalPrice);
    } else {
      productPricing.textContent = formatCurrency(totalPrice);
    }
    addExtra = ''
  }
});
}
function formatCurrency(value) {
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

const fakeBtn = document.querySelector("#fakeCartBtn")
    if(fakeBtn != null){
fakeCartBtn.addEventListener('click', () => {
    let formData = {
     'items': [
       {
      'id': addExtra,
      'quantity': productQuantity
      },
       {
      'id': productVariantId,
      'quantity': productQuantity,
      'properties': {
          [variantVerbage] : refinishingOpt1.value,
        }
      }
     ]
    }
    if (colorUser != null) {
      formData.items[1].properties['Color Selection'] = colorUser.value;
    }
  
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  setTimeout(() => {
      window.location.href = window.Shopify.routes.root + "cart";
    }, 500);
  
  });
}